import { MODAL_TYPE } from 'config/Constants';
import { useStore } from 'hooks/useStore';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authServices } from 'services/authServices';

const NavbarLogic = () => {
  const {
    NavbarStore: { isNavigationRestricted }
  } = useStore();
  const navigate = useNavigate();
  const handleNavigateToHomeScreen = () => {
    if (isNavigationRestricted) {
      if (window.confirm('Are you sure want to navigate??')) {
        navigate('/job-paste');
      }
    } else {
      navigate('/job-paste');
    }
  };
  const {
    UserStore: {
      isLoginLoading,
      toggleLoginLoading,
      isAuthenticated,
      handleLogout,
      userMetadata,
      isUserInfoLoading
    },
    GlobalModalStore: { toggleModal }
  } = useStore();
  const op = useRef<OverlayPanel | null>(null);

  const login = async () => {
    try {
      toggleLoginLoading();
      const res = await authServices.initiateLogin();
      window.location = res.loginRedirectUrl as unknown as Location;
    } catch {
      console.log('Error occured while logging in');
    } finally {
      toggleLoginLoading();
    }
  };
  const logout = async () => {
    handleLogout();
    navigate('/');
  };

  const handleMenuClick = (e: React.MouseEvent) => {
    if (op.current) {
      (op.current as any).toggle(e); // Call the `toggle` method if it exists
    }
  };

  const handleImportSysproJobsModalOpen = () => {
    toggleModal(MODAL_TYPE.PPS_JOB_PASTE_IMPORT_SYSPRO_JOBS_MODAL);
  };

  return {
    handleNavigateToHomeScreen,
    userMetadata,
    isLoginLoading,
    handleLogout,
    isAuthenticated,
    login,
    logout,
    op,
    handleMenuClick,
    isUserInfoLoading,
    handleImportSysproJobsModalOpen
  };
};

export default NavbarLogic;
